import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { ListUsers } from '../../FormControls/ListAllUsers';
import {
  getAllUsers,
} from "../../../../main/slices/storeSlice";
import { LoadingComponent } from '../../LoadingComponent';

export const UsersList = ({ dimensions }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const id = useSelector(({ store }) => store.idStore);
    
    function transformApiData(apiData) {
        const arrayData = Object.values(apiData);
        
        let data =  arrayData.map(item => ({ //FORMATO LIST ACTUAL
            idWLD: item.idWLD,
            email: item.email
        }));

        return data;
    }

    const getAllStoresUser = async () => {
        await dispatch(getAllUsers({
            "origin": "worldpos",
            "store": `${id.value}`,
        }))
        .unwrap()
        .then(({ response }) => {
            if (response.code==200) {
                const formatResponse= transformApiData(response.data);
                setUsers(formatResponse); 
                
            };
            
            setLoading(false);
        })
        .catch(e => {
            setLoading(false)
            false
        });
    }

    useEffect(() => {
        getAllStoresUser();
    }, [dispatch]);

    
    if(loading){
        return (
            <Fragment>
                <LoadingComponent />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div style={{ padding: "0 0.1rem" }}>
                <ListUsers items={users} />
            </div>
        </Fragment>
    )
}